import { Params } from './../plans/planModel';
import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

import * as alertifyjs from 'alertifyjs';

@Component({
  selector: 'app-new-code-people',
  templateUrl: './new-code-people.component.html',
  styleUrls: ['./new-code-people.component.css']
})
export class NewCodePeopleComponent implements OnInit {

  codesList: any[] = [];
  dinamicCodeAll: any;
  personDinamicCode: any = [];
  newPersonDinamicCode: any[] = [];

  filteredCodesList: any[] = [];
  selectedItem: any = null;
  openSearch: boolean = false;
  newCode: any = { code: '', name: '' };
  searchTerm: string = '';

  queryParams: any;
  person: any;
  personCode: any;

  loading: boolean = false;
  loadingAdd: boolean = false;

  constructor(
    private _user: UserService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private el: ElementRef,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.queryParams = params;
      if (this.queryParams?.code) {
        this.getPerson();
      }
    });

    this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const clickedInside = this.el.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.closeSearch();
      }
    });

    this.getPerson();
  }

  private updateFilteredCodes(): void {
    // Filtrar códigos disponibles (no asignados) y aplicar búsqueda
    const availableCodes = this.dinamicCodeAll?.filter((item: any) =>
        item.category === 'person' && 
      !this.personDinamicCode.some((personCode: any) => personCode.code === item.code)
    ) || [];

    // Aplicar filtro de búsqueda
    if (this.searchTerm.trim()) {
      this.filteredCodesList = availableCodes.filter((item: any) =>
        item.code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.filteredCodesList = availableCodes;
    }
}

  async consultAllCodes() {
    try {
      if (Array.isArray(this.dinamicCodeAll)) {
        this.codesList = this.dinamicCodeAll.filter((item: any) => item.category === 'person');
        this.updateFilteredCodes();
      } else {
        this.codesList = [];
        this.filteredCodesList = [];
      }
    } catch (error) {
      console.error('Error en los codigos:', error);
      this.filteredCodesList = [];
    }
  }

  searchCode(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.updateFilteredCodes();
    
    // Abrir dropdown si hay texto de búsqueda
    if (this.searchTerm.trim()) {
      this.openSearch = true;
    }
  }

  selectCode(code: any) {
      this.selectedItem = code;
    this.openSearch = false;
    
    // Actualizar el input para mostrar la selección
    const input = document.getElementById('search-input') as HTMLInputElement;
    if (input) {
      input.value = code.code + ' - ' + code.name;
    }
    
    // Verificar permiso RBAC antes de asignar
    if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['planes.etiquetas.assign'])) {
      alertifyjs.error('No tienes permiso para asignar etiquetas');
      this.clearSelection();
      return;
    }
    
    // Inmediatamente agregar el código seleccionado
    this.addCodeDirectly(code);
  }

  async addCodeDirectly(code: any) {
    this.loadingAdd = true;
    
    let params = {
      code: code.code,
      name: code.name
    };

    try {
      const response = await this._user.createCodesPeople(params, this.personCode);
      alertifyjs.success(`Etiqueta "${code.code}" agregada exitosamente`);
      
      // Limpiar selección y búsqueda
      this.clearSelection();
      
      // Recargar datos para actualizar la lista
      await this.getPerson();
      
    } catch (error) {
      console.error('Error:', error);
      alertifyjs.error(`Error al agregar la etiqueta`);
      // En caso de error, limpiar la selección
      this.clearSelection();
    } finally {
      this.loadingAdd = false;
    }
  }

  async addCode() {
    if (!this.selectedItem) {
      alertifyjs.error('Por favor selecciona una etiqueta');
      return;
    }

    // Verificar permiso RBAC antes de asignar
    if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['planes.etiquetas.assign'])) {
      alertifyjs.error('No tienes permiso para asignar etiquetas');
      return;
    }

    await this.addCodeDirectly(this.selectedItem);
  }

  async getPerson() {
    this.loading = true;
    try {
    const resp = await this._user.getPersonbyCode({
      code: this.queryParams.code,
    });

      if (!this.dinamicCodeAll) {
        let datas = await this._user.getAllCodes();
      this.dinamicCodeAll = datas?.data;
    }

    this.consultAllCodes();

    this.person = resp.resp;
    this.personCode = this.person.person.code;

      let personDinamicCode = this.person?.person?.params?.dinamic_code || [];

      let objCode: any = {};
      for (let item of this.dinamicCodeAll) {
      objCode[item.code] = item;
    }

      if (personDinamicCode?.length > 0) {
        let codes: any = [];
        for (let code of personDinamicCode) {
        let item = {
               code,
            name: objCode[code]?.name || 'Sin nombre'
          };
          codes = [...codes, item];
      }
      this.personDinamicCode = codes || [];
      } else {
      this.personDinamicCode = [];
    }

    this.updateFilteredCodes();
      this.loading = false;
  } catch (error) {
      this.loading = false;
    console.log(error);
    }
  }

  async deleteCodePerson(code: string) {
    // Verificar permiso RBAC antes de eliminar
    if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['planes.etiquetas.delete'])) {
      alertifyjs.error('No tienes permiso para eliminar etiquetas');
      return;
    }

    console.log('Intentando eliminar código:', code);
    console.log('PersonCode:', this.personCode);
    
    try {
      // Agregar confirmación antes de eliminar
      if (!confirm(`¿Estás seguro de que deseas eliminar la etiqueta "${code}"?`)) {
        console.log('Eliminación cancelada por el usuario');
        return;
      }
      
      console.log('Enviando solicitud de eliminación...');
      const response = await this._user.deleteCodeForPerson(code, this.personCode);
      console.log('Respuesta del servidor:', response);
      
      if (response) {
        alertifyjs.success(`Etiqueta eliminada exitosamente`);
        console.log('Recargando datos de la persona...');
        await this.getPerson();
      } else {
        console.log('No se recibió respuesta del servidor');
        alertifyjs.error('No se pudo eliminar la etiqueta');
      }
    } catch (error) {
      console.error('Error completo:', error);
      const errorMessage = error instanceof Error ? error.message : 'Error desconocido';
      alertifyjs.error(`Error al eliminar la etiqueta: ${errorMessage}`);
    }
  }

  searchOpen() {
    this.openSearch = true;
    this.updateFilteredCodes();
    
    // Enfocar el input
    setTimeout(() => {
      const input = document.getElementById('search-input') as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 100);
  }

  closeSearch() {
    this.openSearch = false;
    this.selectedItem = null;
  }

  clearSelection() {
    this.selectedItem = null;
    this.searchTerm = '';
    this.openSearch = false;
    
    // Limpiar el input
    const input = document.getElementById('search-input') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    
    this.updateFilteredCodes();
  }
}
